<template>
    <span class="cp ms-hover c_theme" @click="topage()"> {{ datatext }} </span>
</template>

<script>
/**
*【重要】列表条件筛选组合格式说明
* topage()函数按照此说明进行组合跳转 
*
第一部分：children 一横排条件定义
children = {
    type: "",                   // type【field_blur模糊匹配、field精确匹配、field_date日期】
    key: "",                    // 传参key如：investigator_num
    key_label: "",              // 总条件显示的label如：研究者姓名、药物靶点
    children: [node1,node2],    //children.children
} 
第二部分：children.children  横排内单个条件定义
node1 = {
    "label": "",    // label: 单个条件显示的label如：张三
    "value": "",    // value: 传参value：1102
}
*/
export default {
    name: "my-router-to-list",
    props: {
        data:{
            type: Object,
            default:()=>{}
        },
        datatext:{
            type: Number 
        },
        toname:{
            type: String
        },
        todbid:{
            type: Number 
        },
        params:{
            type: Array,
            default:()=>[]
        }
    },
    methods:{
        // 跳转到 - 列表
        topage(){
            // 为组合children作准备：根据base_search配置生成条件
            let tps = function(params) {
                let res = 'field';
                if (params == 1) {
                    res = 'field_blur';
                }else if (params == 4) {
                    res = 'field_date';
                }
                return res;
            }
            let condition = this.$store.state.ks1hfc6b_condition;
            let pms = [];
            if (condition.length>0) {
                condition.forEach((v)=>{
                    if (v?.tps.length>0) {
                        v.tps.forEach((vv)=>{
                            let tmp = {field:vv.key, type: tps(vv.type),key_label: vv.key_title||vv.title,hide: vv.hide};
                            pms.push(tmp);
                        })
                    }else{
                        let tmp = {field:v.key, type: tps(v.type),key_label: v.title,hide: v.hide};
                        pms.push(tmp);
                    }
                })
            }
            let params = this.params;
            // 清空已有条件
            this.$store.state.ksk6p8gl_search_condition.children = [];
            // 关闭筛选条件第二列，避免历史的勾选状态
            this.$store.commit("ksmwccyb_active_index_reset");
            // 定义children
            let children = {};
            params.forEach((v) => {
                // 每次循环重置children
                children = {
                    key: v.key,
                    type: "",
                    key_label: "",
                    children: [],
                };
                // ===== 组合children ===== //
                pms.forEach((vv)=>{
                    // base_search配置的筛选字段
                    if (v.key == vv.field) {
                        children.type = vv.type;
                        children.key_label = vv.key_label;
                        children.hide = vv.hide;
                        if (vv.type == 'field_date') {
                            v.type = 'value_date'
                        }
                    }
                })
                // 存在children.type才添加到检索条件
                if (children.type) {
                    // ===== 组合children.children ===== //
                    v.value.forEach(node => {
                        // 单独处理日期格式
                        if (v?.type == 'value_date') {
                            let tmptime = node?.value.split(':');
                            let node_date = {
                                type: v.type,
                                start_value: tmptime[0]
                                    ? tmptime[0]
                                    : null,
                                end_value: tmptime[1]
                                    ? tmptime[1]
                                    : null,
                            };
                            children.children.push(node_date);
                        }else{
                            children.children.push(node);
                        }
                    });
                    // push加到总的条件下
                    this.$store.state.ksk6p8gl_search_condition.children.push(children);
                }
            });
            // 重置当分页前页
            this.$store.state.kslhow0s_search_list.qs={
                page: 1,
                pagesize: 10
            }
            // 跳转到指定的routename
            this.$router.push({ name: this.toname})
            // 发送请求、获得结果列表
            this.$nextTick(()=>{
                this.$store.dispatch("kslhow0s_search_list",{dbid: this.todbid});
            }) 
        }
    }
};
</script>

<style lang="less">
// .el-table__body{
//     .el-table__row:hover span.ms-hover{
//         color: red;
//     }
// }
</style>
